export const House = ({size = 21, className = ''}) => {
  return (
    <i style={{width: size, height: size}} className={`flex justify-center items-center ${className}`}>
      <svg viewBox="0 0 42 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.25 16.8667L21.15 2.16666L40.05 16.8667V39.9667C40.05 41.0806 39.6075 42.1489 38.8198 42.9365C38.0322 43.7242 36.9639 44.1667 35.85 44.1667H6.45C5.33609 44.1667 4.2678 43.7242 3.48015 42.9365C2.6925 42.1489 2.25 41.0806 2.25 39.9667V16.8667Z" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.85 44.1667V23.1667H27.45V44.1667" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>

    </i>
  )
};
